import BootstrapForm from "react-bootstrap/Form";

import GroupRow from "./GroupRow";
import InputGroup from "./InputGroup";
import MaterialContainer from "./MaterialContainer";
import { FormControl, TextInput, DatePicker, DateRange } from "./Control";
import { Dropdown } from "./Control/Dropdown";
import { RadioGroup } from "./RadioGroup";
import Check from "./Check";
import HelperTextLabel from "./HelperTextLabel";

const Form = {
  ...BootstrapForm,
  GroupRow,
  MaterialContainer,
  TextInput,
  InputGroup,
  MaterialTextInput: FormControl.Input,
  Dropdown,
  MaterialDropdown: FormControl.Dropdown,
  DatePicker,
  DateRange,
  MaterialDatePicker: FormControl.DatePicker,
  Autocomplete: FormControl.Autocomplete,
  RadioGroup,
  Check,
  HelperTextLabel,
};

export { Form, FormControl };
